<template>
  <div class="invoice">
    <v-row>
      <v-col align="center">
        <h2>{{ $t('message.invoice') }}</h2>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-card width="100%" class="pa-12">
        <v-row>
          <billing-info :contract-id="2" />
        </v-row>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BillingInfo from '../components/invoice/BillingInfo.vue'

export default {
  name: 'Invoice',
  components: {
    BillingInfo
  },
  computed: {
    ...mapGetters({
      isMobile: 'common/isMobile',
      restaurants: 'restaurants/restaurants',
      contracts: 'contracts/contracts'
    })
  }
}
</script>

<style lang="scss" scoped>
.invoice {
  height: 100%;
  width: 100%;
  background-color: #eae8e0;
  padding: 60px 24px 40px 24px;
}
</style>
